module.exports = __webpack_public_path__ + "img/santander.a90b0709.jpg";